module.exports = __webpack_public_path__ + "static/img/gpt72.e5568911.jpg";